module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-01 3.8eda1b48.png";